import React from 'react';
import { connect } from 'react-redux';
import HomePageJumbotron from './HomePageJumbotron';
import { Helmet } from "react-helmet";

class HomePage extends React.Component {
    constructor(props, context) {
        super(props, context);
    }
    render() {
        return (
            <div className="homePage">
                <Helmet>
                    <title>Home | Matthew Dove</title>
                </Helmet>
                <h1>Matthew Dove</h1>
                <HomePageJumbotron />
            </div>
        );
    }
}

HomePage.propTypes = {
};

function mapStateToProps() {
    return {
    };
}

export default connect(
    mapStateToProps
)(HomePage);



// WEBPACK FOOTER //
// ./src/components/homePage/HomePage.js